import { render, staticRenderFns } from "./radar2.vue?vue&type=template&id=84cfb678&scoped=true&"
import script from "./radar2.vue?vue&type=script&lang=js&"
export * from "./radar2.vue?vue&type=script&lang=js&"
import style0 from "./radar2.vue?vue&type=style&index=0&id=84cfb678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cfb678",
  null
  
)

export default component.exports